export const Gallery = (() => {
	'use strict';

	function init() {
		$(window).resize(function () {
			if ($(window).width() < 768) {
				$('.pxblock--gallery__carousel.conveyor').attr('data-conveyor-view', 2);
			}
		});
		if ($(window).width() < 768) {
			$('.pxblock--gallery__carousel.conveyor').attr('data-conveyor-view', 2);
		}
	}

	return {
		init: init,
		name: 'gallery',
	};
})();
